<template>
	<v-container>
		<v-layout>
			<v-flex xs-12>
				<v-timeline align-top :dense="$vuetify.breakpoint.smAndDown">
					<v-timeline-item v-for="update in updates" :key="update.id" :color="update.color ? update.color : 'primary'" fill-dot>
						<span v-if="$vuetify.breakpoint.mdAndUp" slot="opposite" :class="'headline '+update.color+'--text'" v-text="formatDate(update.date)"></span>
						<v-card :color="update.color" dark>
							<v-card-title class="title">
								<h1 class="headline">{{update.status == 'draft' ? `Draft ${update.title}` : update.title}}</h1>
							</v-card-title>
							<v-card-text class="white text--primary">
								<p v-html="update.content"></p>
							</v-card-text>
							<v-card-actions v-if="signedInUserAdmin">
								<v-dialog v-model="deleteDialog" persistent max-width="290">
			            <v-card>
			              <v-card-title class="headline font-weight-regular error white--text">Delete Update?</v-card-title>
			              <v-card-text>By deleting this update you understand that... the update will be deleted. If you would like to delete the update, please click delete</v-card-text>
			              <v-card-actions>
			                <v-spacer></v-spacer>
			                <v-btn flat @click.native="deleteDialog = false">Cancel</v-btn>
			                <v-btn color="error" @click.native="remove(update.id)">Delete</v-btn>
			              </v-card-actions>
			            </v-card>
			          </v-dialog>
								<v-btn color="white" @click.native="deleteDialog = true" :class="update.color+'--text'">
									Delete
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-timeline-item>
			    <v-timeline-item v-if="signedInUserAdmin" fill-dot class="white--text mb-5" :color="newPost.color">
			      <span slot="icon">JS</span>
			      <v-card :color="newPost.color">
							<v-card-title class="title">
								<h1 class="headline white--text">New Update</h1>
							</v-card-title>
							<v-card-text class="white black--text">
								<v-toolbar flat dense card>
									<v-btn-toggle v-model="newPost.type" mandatory multiple>
										<v-btn flat value="email">
											<v-icon color="red">email</v-icon>
										</v-btn>
										<v-btn flat value="social">
											<v-icon color="indigo">person</v-icon>
										</v-btn>
										<v-btn flat value="test">
											<v-icon color="grey">build</v-icon> Test
										</v-btn>
									</v-btn-toggle>
									<v-spacer></v-spacer>
									<v-btn-toggle v-model="newPost.color" mandatory>
										<v-btn flat value="deep-orange">
											<v-icon color="red darken-2">colorize</v-icon>
										</v-btn>
										<v-btn flat value="orange">
											<v-icon color="orange">colorize</v-icon>
										</v-btn>
										<v-btn flat value="teal">
											<v-icon color="green darken-2">colorize</v-icon>
										</v-btn>
										<v-btn flat value="indigo">
											<v-icon color="indigo">colorize</v-icon>
										</v-btn>
									</v-btn-toggle>
								</v-toolbar>
								<v-divider></v-divider>
								<v-text-field single-line full-width light hide-details
					        v-model="newPost.title" label="Update Title" class="quill">
					      </v-text-field>
					      <v-divider class="my-3"></v-divider>
					      <BaseEditor v-model="newPost.content"></BaseEditor>
							</v-card-text>
							<v-card-actions color="white">
								<v-spacer></v-spacer>
								<v-btn depressed color="white" @click.native="draft" :class="newPost.color+'--text'">
									Save Draft
								</v-btn>
								<v-btn depressed color="white" @click.native="post" :class="newPost.color+'--text'">
			            Post
			          </v-btn>
							</v-card-actions>
						</v-card>
			    </v-timeline-item>
			  </v-timeline>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	import BaseEditor from '../components/BaseEditor';

	const fb = require('../firebaseConfig.js');
	import { mapState } from 'vuex';

	export default {
		name: "Updates", 
		components: BaseEditor,
		data(){
			return {
				updates: [],
				editor: null,
				deleteDialog: false, 
				newPost:{
					title: null, 
					content: null, 
					author: null, 
					date: null, 
					status: null,
					type: null,
					color: 'orange'
				},
				dateOptions: {
					weekday: 'long', 
					year: 'numeric', 
					month: 'long', 
					day: 'numeric' 
				}
			}
		}, 
		computed:{
			 ...mapState({
        signedInUser: state => state.users.currentUser, 
        signedInUserAdmin: state => state.users.admin
      }), 
      userIsSignedIn() {
        //Should call a firebase get to pull user from store
        return !(Object.keys(this.signedInUser).length === 0);
      },
		}, 
		mounted(){

		},
		methods: {
			async getUpdates(){
				if(this.signedInUserAdmin){
					let updatesRef = fb.db.collection('updates').orderBy('date', 'desc');
					let updates = await updatesRef.get();

					updates.forEach(update => {
						var data = update.data();
						this.updates.push({...data, id: update.id});
					});


				} else {
					let updatesRef = fb.db.collection('updates').where('status', '==', 'published').orderBy('date', 'desc');
					let updates = await updatesRef.get();

					updates.forEach(update => {
						var data = update.data();
						this.updates.push({...data, id: update.id});
					})

				}
			}, 
			formatDate(date){
				return date.toDate ? date.toDate().toLocaleDateString('en-US', this.dateOptions) : date.toLocaleDateString('en-US', this.dateOptions);
			},
			async post(){
				// console.log(this.signedInUser);

				let newPost = {
					title: this.newPost.title, 
					content: this.newPost.content, 
					author: this.signedInUser, 
					date: new Date(), 
					status: 'published',
					type: this.newPost.type,
					color: this.newPost.color
				};

		    let updatesRef = fb.db.collection('updates');
		    await updatesRef.add(newPost);

		    this.updates.shift(newPost);

		    this.newPost.title = null;
		    this.newPost.content = null;
		    this.newPost.author = null; 
		    this.newPost.date = null;
		    this.newPost.type = null;
		    this.newPost.status = null;
		    this.newPost.color = 'orange';
			}, 
			async draft(){
				let newPost = {
					title: this.newPost.title, 
					content: this.newPost.content, 
					author: this.signedInUser, 
					date: new Date(), 
					status: 'draft',
					type: null,
					color: this.newPost.color
				};

		    let updatesRef = fb.db.collection('updates');
		    await updatesRef.add(newPost);

		    this.updates.push(newPost);

		    this.newPost.title = null;
		    this.newPost.content = null;
		    this.newPost.author = null; 
		    this.newPost.date = null;
		    this.newPost.status = null;
		    this.newPost.type = null;
		    this.newPost.color = 'orange';
			}, 
			async remove(id){
				let locationsRef = fb.db.collection('updates');
    		await locationsRef.doc(id).delete();

    		this.updates = this.updates.filter(function(update){
    			return update.id !== id;
    		})
			}, 
		},
		mounted(){
			this.getUpdates();
		}, 
		watch: {

		}
	}
</script>
<style>
</style>